const ENV = process.env.REACT_APP_ENV || "";
let baseUrl = "";

switch (ENV?.toLocaleLowerCase()) {
  case "dev":
    baseUrl = "https://8xh7yebhrl.execute-api.us-east-1.amazonaws.com/dev";
    break;
  case "prod":
    baseUrl = "https://3z0wjjz75d.execute-api.us-east-1.amazonaws.com/prod";
    break;
  default:
    baseUrl = "http://localhost:4000"; 
}

export default baseUrl;
